import { PaymentType } from '@trnsact/trnsact-shared-types';

import { TemplateFormValues, StagesFormValues, TemplateConstructorMode } from '../../types';

export const initialStagesConstructorFormValue: TemplateFormValues = {
  isActive: false,
  description: '',
  templateName: '',
  businessProcess: '',
  applyRules: {
    paymentType: PaymentType.Financing,
  },
};

export const stagesConstructorFormRow: StagesFormValues = {
  id: null,
  name: '',
  checklist: [],
  recipients: [],
};

export const constructorSubmitLabelByMode: Record<TemplateConstructorMode, string> = {
  create: 'Create',
  edit: 'Save',
  copy: 'Copy',
};
